/* eslint-disable no-nested-ternary */
import i18n from 'i18next';

export const convertMinutesToTimeString = (value) => {
  if (value < 60) {
    return `${value} ${i18n.t('TagFormat.Datetime.Minute')}`;
  }
  if (value % 60 === 0) {
    return `${Math.floor(value / 60)} ${i18n.t('TagFormat.Datetime.Hour')}`;
  }
  return `${Math.floor(value / 60)} ${i18n.t('TagFormat.Datetime.Hour')} ${value % 60} ${i18n.t('TagFormat.Datetime.Minute')}`;
};

export const convertMaterialsToString = ({ isCourse, isOnboarding, value }) => {
  if (!value) return null;

  const isMultiple = value !== 1;
  const typeKey = `${isCourse ? 'Module' : isOnboarding ? 'Material' : 'Lesson'}${isMultiple ? 's' : ''}`;

  return `${value} ${i18n.t(`TagFormat.Materials.${typeKey}`)}`;
};

export const convertTestToString = (isFinal) =>
  `TagFormat.Test.${isFinal ? 'FinalTest' : 'Test'}`;

export const getAllImagesFromArticle = (htmlString) =>
  htmlString
    ? [...htmlString.matchAll(/src="([^">]+)"/g)].map((match) => match[1])
    : [];

export const transformActivities = (activities) =>
  activities?.flatMap((activity) => {
    if (Array.isArray(activity.url) && activity.url.length > 1) {
      return activity.url.map((url) => ({
        ...activity,
        url,
      }));
    }
    return {
      ...activity,
      url: Array.isArray(activity.url) ? activity.url[0] : activity.url,
    };
  });

export const replaceUrls = (htmlString, imageRecords) => {
  let newHtmlString = htmlString;
  imageRecords.forEach((record) => {
    newHtmlString = htmlString.replace(
      record.url,
      URL.createObjectURL(record.file)
    );
  });
  return newHtmlString;
};
